import { Type } from "nanium/objects";

export class GeoLocationFilterType {
    @Type(Number) centerLatitude: number;
    @Type(Number) centerLongitude: number;
    @Type(Number) radius: number;
}
